export function applyShoutcastUrlFallback(url = '') {
    const { protocol, pathname, search, host } = new URL(url);
    const shoutcastHack = pathname.endsWith('/') ? ';' : '/;';
    if (pathname.endsWith(shoutcastHack)) {
        return url;
    }
    return `${protocol}//${host}${pathname}${shoutcastHack}${search}`;
}
export function shouldApplyShoutcastUrlFallback(url, ignoredPatterns = []) {
    if (ignoredPatterns.length &&
        new RegExp(ignoredPatterns.join('|')).test(url)) {
        return false;
    }
    return !isShoutcastUrl(url);
}
export function isShoutcastUrl(url) {
    return url.includes('/;');
}
